import ReactMarkdown from 'react-markdown';
import { Megaphone, BoxArrowUpRight } from 'react-bootstrap-icons';

import { isWorkspacePath, type AnnouncementDraft } from '../../../../lib/notifications/announcements';
import { formatNzDate } from '@/utils/relativeTime';

interface AnnouncementPreviewProps {
  draft: AnnouncementDraft;
  /** Unseen announcements a person would have waiting behind this one. */
  earlier?: number;
}

/**
 * Roughly what a person sees when they next open Numa. The workspace's own
 * brand colour replaces the purple, and links do nothing here.
 */
export function AnnouncementPreview({ draft, earlier = 0 }: AnnouncementPreviewProps) {
  const hasLink = Boolean(draft.linkUrl?.trim() && draft.linkLabel?.trim());
  const today = formatNzDate(new Date());
  return (
    <div className="announcement-preview" aria-label="Preview of the pop-up">
      <div className="announcement-preview__header">
        <span className="announcement-preview__icon">
          <Megaphone size={18} />
        </span>
        <div>
          <div className="announcement-preview__overline">Announcement · {today}</div>
          <div className="announcement-preview__title">{draft.title.trim() || 'Your title'}</div>
        </div>
      </div>
      <div className="announcement-preview__body">
        {draft.body.trim() ? (
          <ReactMarkdown
            disallowedElements={['img']}
            components={{ a: ({ children }) => <span className="announcement-preview__link">{children}</span> }}
          >
            {draft.body}
          </ReactMarkdown>
        ) : (
          <p className="announcement-preview__placeholder">Your message</p>
        )}
      </div>
      <div className="announcement-preview__footer">
        {hasLink && (
          <span className="announcement-preview__primary">
            {draft.linkLabel}
            {!isWorkspacePath(draft.linkUrl?.trim() ?? '') && <BoxArrowUpRight size={12} className="ms-2" />}
          </span>
        )}
        <span className={hasLink ? 'announcement-preview__secondary' : 'announcement-preview__primary'}>Got it</span>
        {earlier > 0 && (
          <span className="announcement-preview__earlier">
            See {earlier} earlier announcement{earlier === 1 ? '' : 's'}
          </span>
        )}
      </div>
    </div>
  );
}
